import {
  QueryBuilderProperty,
  QueryBuilderSchema,
} from 'vet-bones/utils/queryBuilder';

import { RULES_QUERY_BUILDER_TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import { RDF_TYPE_IRI } from 'src/templates/queries/iris';
import { colors } from 'src/templates/styles/colors';

export const IF_QUERY_BUILDER_SCHEMA: QueryBuilderSchema = {
  colors: {
    darkIcon: colors.darkIcon,
    anyClassColorId: colors.queryBuilderGrayId,
  },
  copy: copy.rulesIfQueryBuilder,
  testIds: RULES_QUERY_BUILDER_TEST_IDS,
  duplicateDisabled: true,
  hiddenOperators: new Set(),
  orDisabled: true,
};

export const THEN_QUERY_BUILDER_SCHEMA: QueryBuilderSchema = {
  colors: {
    darkIcon: colors.darkIcon,
    anyClassColorId: colors.queryBuilderGrayId,
  },
  copy: copy.rulesThenQueryBuilder,
  testIds: RULES_QUERY_BUILDER_TEST_IDS,
  andNotDisabled: true,
  comparisonDisabled: true,
  duplicateDisabled: true,
  instanceDisabled: true,
  orDisabled: true,
  limitOperators: true,
};

export const SEARCH_TYPE_RELATIONSHIP: QueryBuilderProperty = {
  iri: RDF_TYPE_IRI,
  label: copy.components.projectRuleDetailDrawer.classifyProperty,
  isDatatype: false,
  domains: new Set([]),
  ranges: new Set([]),
};
